export const SETTING_TYPES = {
  PULL: 'pull',
  PUSH: 'push',
};

export const WEBSITE_SETTING = 'website';
export const TITLE_SETTING = 'title';
export const HOURS_SETTING = 'hours';
export const PHONE_NUMBERS_SETTING = 'phoneNumbers';
export const ADDRESS_SETTING = 'address';
export const SERVICES_SETTING = 'services';
export const CATEGORIES_SETTING = 'categories';
export const MENU_SETTING = 'menu';
export const REVIEWS_SETTING = 'reviews';
export const PROFILE_SETTING = 'profile';
export const MEDIA_SETTING = 'media';
export const PLACE_ACTIONS_SETTING = 'placeActions';

export const SETTING_LOGICAL_ORDER = [
  WEBSITE_SETTING,
  TITLE_SETTING,
  PROFILE_SETTING,
  ADDRESS_SETTING,
  HOURS_SETTING,
  PHONE_NUMBERS_SETTING,
  CATEGORIES_SETTING,
  SERVICES_SETTING,
  MENU_SETTING,
  MEDIA_SETTING,
  REVIEWS_SETTING,
  PLACE_ACTIONS_SETTING,
];
